import { render, staticRenderFns } from "./ResponsibilityCardHeader.vue?vue&type=template&id=de1cd7e6"
import script from "./ResponsibilityCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityCardHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityCardHeader.vue?vue&type=style&index=0&id=de1cd7e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports